import PropTypes from "prop-types"

import Divider from "components/ui/divider"
import Media from "components/ui/media"

import LineItemDesktop from "./desktop"
import LineItemMobile from "./mobile"

const LineItems = ({ line_items }) => {
  return line_items.map((line_item, index) => (
    <div
      data-ge-basket-cartitemid={`${line_item.style_code}-${line_item.sku}`}
      key={`cartItem-${line_item.id}`}
    >
      <Media greaterThanOrEqual="tablet">
        <LineItemDesktop item={line_item} />
      </Media>
      <Media lessThan="tablet">
        {index !== 0 && <Divider className="bg-grey-20 my-24" />}
        <LineItemMobile item={line_item} />
      </Media>
    </div>
  ))
}

LineItems.propTypes = {
  line_items: PropTypes.array,
}

export default LineItems
